/**
 * Charge le player YouTube uniquement quand la section est visible (Intersection Observer).
 * Économise ~720 KiB de JavaScript inutilisé sur les pages où la vidéo est hors écran.
 */
(function () {
  const YOUTUBE_EMBED_LOADED = 'youtube-embed-loaded';

  function loadYoutubeScript(callback) {
    if (window.YT?.loaded) {
      callback?.();
      return;
    }
    const existing = document.querySelector('script[src*="youtube-iframe"]');
    if (existing) {
      window.YT?.ready(callback);
      return;
    }
    const loaderScript = document.querySelector('script[data-youtube-iframe-url]');
    const scriptUrl = loaderScript?.getAttribute('data-youtube-iframe-url');
    if (!scriptUrl) return;
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => (window.YT?.ready(callback) || callback?.());
    document.head.appendChild(script);
  }

  function loadEmbedWhenVisible(entry) {
    const el = entry.target;
    if (el.hasAttribute(YOUTUBE_EMBED_LOADED)) return;
    el.setAttribute(YOUTUBE_EMBED_LOADED, '');
    const videoId = el.getAttribute('data-youtube-id');
    if (!videoId) return;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;
    iframe.className = el.getAttribute('data-youtube-class') || 'responsive-video';
    iframe.width = el.getAttribute('data-youtube-width') || '1080';
    iframe.height = el.getAttribute('data-youtube-height') || '580';
    iframe.title = 'YouTube video player';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    el.replaceWith(iframe);
  }

  function initSectionWhenVisible(entry) {
    const section = entry.target;
    if (section.hasAttribute('data-youtube-ready')) return;
    section.setAttribute('data-youtube-ready', '');
    loadYoutubeScript();
  }

  function init() {
    const embedObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadEmbedWhenVisible(entry);
          }
        });
      },
      { rootMargin: '100px', threshold: 0.01 }
    );

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            initSectionWhenVisible(entry);
          }
        });
      },
      { rootMargin: '150px', threshold: 0.01 }
    );

    document.querySelectorAll('[data-youtube-embed]').forEach((el) => embedObserver.observe(el));
    document.querySelectorAll('[data-youtube-section]').forEach((el) => sectionObserver.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
